import React from "react";

import "./App.css";
import "./App.scss";
import Header from "./components/Header/Header";
import About from "./components/About/About";
import Mockup from "./components/Mockup/Mockup";
import Ecommerce from "./components/Ecommerce/Ecommerce";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <About />
      <Mockup />
      <Ecommerce />
      <Footer />
    </div>
  );
}

export default App;
